import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getWarehouseList,
	addNewWarehouse,
	updateWarehouse,
	deleteWarehouse,
	getWarehouse,
	synchronizeWarehouse,
	synchronizeWarehouseItems,
	synchronizeWarehouseGroup,
	getWarehouseByEstablishment,
	getWarehouseGroupExist,

} from '../warehouse/thunk';

export const initialState = {
	itemWarehouseList: [],
	itemWarehouseDetail: null,
	itemWarehouse: null,
	isWarehouseLoading: false,
	isWarehouseSuccess: false,

	warehouseList: [],
	warehouseListSelect: [],
	isLoadingWarehouseList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const WarehouseSlice = createSlice({
	name: 'Warehouses',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWarehouse.fulfilled, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = true;
			state.itemWarehouse = action.payload;
			state.isLoadingWarehouseList = false;
		});
		builder.addCase(getWarehouse.pending, state => {
			state.isWarehouseLoading = true;
			state.isWarehouseSuccess = null;
			state.error = null;
			state.isLoadingWarehouseList = true;
		});
		builder.addCase(getWarehouse.rejected, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = false;
			state.error = action.error.message;
			state.isLoadingWarehouseList = false;
		});

		builder.addCase(getWarehouseByEstablishment.fulfilled, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = true;
			state.itemWarehouse = action.payload;
			state.isLoadingWarehouseList = false;
		});
		builder.addCase(getWarehouseByEstablishment.pending, state => {
			state.isWarehouseLoading = true;
			state.isWarehouseSuccess = null;
			state.error = null;
			state.isLoadingWarehouseList = true;
		});
		builder.addCase(getWarehouseByEstablishment.rejected, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = false;
			state.error = action.error.message;
			state.isLoadingWarehouseList = false;
		});


		builder.addCase(getWarehouseList.pending, state => {
			state.isWarehouseSuccess = true;
			state.error = null;
			state.isLoadingWarehouseList = true;
		});
		builder.addCase(getWarehouseList.fulfilled, (state, action) => {
			state.itemWarehouseList = action.payload;
			state.warehouseList = action.payload;
			state.isLoadingWarehouseList = false;
			state.isWarehouseSuccess = true;

			let warehouseListSelect = [];
			action.payload.map(item =>
				warehouseListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.warehouseListSelect = warehouseListSelect;
		});
		builder.addCase(getWarehouseList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingWarehouseList = false;
			state.isWarehouseSuccess = true;
		});
		builder.addCase(addNewWarehouse.fulfilled, (state, action) => {
			state.itemWarehouseList.push(action.payload);
			state.warehouseList.push(action.payload);
			state.isLoadingWarehouseList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewWarehouse.pending, (state, action) => {
			state.isLoadingWarehouseList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewWarehouse.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingWarehouseList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateWarehouse.fulfilled, (state, action) => {
			state.itemWarehouseList = state.itemWarehouseList.map(warehouse =>
				warehouse.warehousename === action.payload.old_warehouse
					? { ...warehouse, ...action.payload.updated_warehouse }
					: warehouse
			);
			state.warehouseList = state.warehouseList.map(warehouse =>
				warehouse._id.toString() === action.payload._id.toString()
					? { ...warehouse, ...action.payload }
					: warehouse
			);
			state.isLoadingWarehouseList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateWarehouse.pending, state => {
			state.isLoadingWarehouseList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateWarehouse.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingWarehouseList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWarehouse.fulfilled, (state, action) => {
			state.itemWarehouseList = current(state.itemWarehouseList).filter(
				item => item._id !== action.payload._id
			);
			state.warehouseList = current(state.warehouseList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingWarehouseList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteWarehouse.pending, (state, action) => {
			state.isLoadingWarehouseList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteWarehouse.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingWarehouseList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});



		builder.addCase(synchronizeWarehouse.fulfilled, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = true;
			state.itemWarehouseDetail = action.payload;
			state.isLoadingWarehouseList = false;
		});
		builder.addCase(synchronizeWarehouse.pending, state => {
			state.isWarehouseLoading = true;
			state.isWarehouseSuccess = null;
			state.error = null;
			state.isLoadingWarehouseList = true;
		});
		builder.addCase(synchronizeWarehouse.rejected, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = false;
			state.error = action.error.message;
			state.isLoadingWarehouseList = false;
		});

		builder.addCase(synchronizeWarehouseItems.fulfilled, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = true;
			state.itemWarehouseDetail = action.payload;
			state.isLoadingWarehouseList = false;
		});
		builder.addCase(synchronizeWarehouseItems.pending, state => {
			state.isWarehouseLoading = true;
			state.isWarehouseSuccess = null;
			state.error = null;
			state.isLoadingWarehouseList = true;
		});
		builder.addCase(synchronizeWarehouseItems.rejected, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = false;
			state.error = action.error.message;
			state.isLoadingWarehouseList = false;
		});

		builder.addCase(synchronizeWarehouseGroup.fulfilled, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = true;
			state.itemWarehouseDetail = action.payload;
			state.isLoadingWarehouseList = false;
		});
		builder.addCase(synchronizeWarehouseGroup.pending, state => {
			state.isWarehouseLoading = true;
			state.isWarehouseSuccess = null;
			state.error = null;
			state.isLoadingWarehouseList = true;
		});
		builder.addCase(synchronizeWarehouseGroup.rejected, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = false;
			state.error = action.error.message;
			state.isLoadingWarehouseList = false;
		});

		builder.addCase(getWarehouseGroupExist.fulfilled, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = true;
			state.itemWarehouseDetail = action.payload;
			state.isLoadingWarehouseList = false;
		});
		builder.addCase(getWarehouseGroupExist.pending, state => {
			state.isWarehouseLoading = true;
			state.isWarehouseSuccess = null;
			state.error = null;
			state.isLoadingWarehouseList = true;
		});
		builder.addCase(getWarehouseGroupExist.rejected, (state, action) => {
			state.isWarehouseLoading = false;
			state.isWarehouseSuccess = false;
			state.error = action.error.message;
			state.isLoadingWarehouseList = false;
		});

	},
});

export const { setRequireCloseModal } = WarehouseSlice.actions;

export default WarehouseSlice.reducer;
